const config = {
    apiBaseUrl : process.env.REACT_APP_API_END_POINT || 'http://localhost:5100'
}
export default config;